import React from 'react';
import { Link } from 'react-router-dom';

export const PainelAdminLoginView = ({
  password,
  setPassword,
  showPassword,
  setShowPassword,
  loginError,
  handleLogin,
}) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 to-gray-800" data-testid="painel-admin-login-screen">
      <div className="bg-white/10 backdrop-blur">
        <div className="max-w-4xl mx-auto px-4 py-4 flex items-center justify-between">
          <Link to="/" className="text-gray-300 hover:text-white" data-testid="painel-admin-login-back-link">← Voltar ao Site</Link>
          <span className="text-blue-400 font-bold" data-testid="painel-admin-login-brand">RH Consulting Holdings</span>
        </div>
      </div>

      <div className="max-w-2xl mx-auto px-4 pt-8" data-testid="painel-admin-login-progress">
        <div className="flex justify-center mb-2">
          <span className="text-sm font-medium text-blue-400">Área Restrita</span>
        </div>
        <div className="h-1 bg-gray-700 rounded-full overflow-hidden">
          <div className="h-full bg-blue-500 w-1/4"></div>
        </div>
      </div>

      <div className="max-w-md mx-auto px-4 py-8">
        <div className="bg-white rounded-2xl shadow-2xl p-6" data-testid="painel-admin-login-card">
          <div className="flex items-center gap-3 mb-6">
            <span className="text-4xl">🔐</span>
            <div>
              <h2 className="text-2xl font-bold text-gray-900" data-testid="painel-admin-login-title">Painel Administrativo</h2>
              <p className="text-gray-600">Acesso restrito</p>
            </div>
          </div>

          <form onSubmit={handleLogin} className="space-y-4" data-testid="painel-admin-login-form">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Senha de Acesso *</label>
              <div className="relative">
                <input
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={(event) => setPassword(event.target.value)}
                  required
                  autoFocus
                  className="w-full px-4 py-3 pr-20 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-center text-lg tracking-widest text-gray-900"
                  placeholder="Digite a senha"
                  data-testid="painel-admin-password-input"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword((prev) => !prev)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-sm font-medium text-blue-600 hover:text-blue-700"
                  data-testid="painel-admin-toggle-password-button"
                >
                  {showPassword ? 'Ocultar' : 'Mostrar'}
                </button>
              </div>
              <p className="mt-2 text-xs text-gray-500">A senha aceita letras e números.</p>
            </div>

            {loginError && (
              <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm" data-testid="painel-admin-login-error">
                {loginError}
              </div>
            )}

            <button
              type="submit"
              disabled={!password}
              className="w-full px-4 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition disabled:bg-gray-300 disabled:cursor-not-allowed font-semibold"
              data-testid="painel-admin-login-submit-button"
            >
              Entrar →
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};
